import { useState } from "react";
import {Link, useNavigate} from "react-router-dom";
import Modal from "../Modal";
import { useSweetAlert } from "../../context/sweetAlertContext";

export default function Footer() {
    const navigate = useNavigate();
    const [isOpen,setIsOpen] = useState(false);
    const sweetAlert = useSweetAlert();
    const showPolicy = () => {
        let text = ""
    
            text="بعد از تکمیل اطلاعات خواسته شده در فرم‌های تبلیغ و زدن دکمه نهایی ثبت، مبلغ کارمزد ثبت این تبلیغ، از کیف پول کارسود شما کسر می‌گردد و سپس برای بررسی به ادمین تبلیغات ارجاع می‌شود و نهایتاً ظرف ۲۴ ساعت بررسی انجام شده و در صورت تایید، تبلیغ شما منتشر خواهد شد اما در صورت عدم تایید، تبلیغ شما رد خواهد شد و شما می‌بایست تبلیغ خود را ویرایش و اصلاح نمایید و مجدداً پس از ویرایش و اصلاح تبلیغ خود را ثبت نمایید. در صورت رد تبلیغ، کارمزد پرداختی شما مجدد به کیف پول کارسود شما واریز می‌گردد" +
            "\n" +
            "\n" +
            "نکته: مبالغ واریز شده به کیف پول کارسود شما قابل واریز به حساب بانکی شما نیست و شما فقط می‌توانید از آن در کارسود استفاده نمایید و کالاها و خدمات مورد نظر خود را در کارسود خرید نمایید" +
            "\n" +
            "\n" +
            "پس برای اینکه تبلیغ شما تایید و منتشر شود حتماً به نکات زیر توجه نمایید" +
            "\n" +
            "\n" +
            "1- تبلیغ شما باید مطابق با قوانین جمهوری اسلامی ایران باشد" +
            "\n" +
            "2- تبلیغ خود کارسود و کد دعوت کارسود و دیگر خدمات و وب سایت‌های مربوط به آن ممنوع می‌باشد" +
            "\n" +
            "3- تبلیغ وب سایت‌ها و اپلیکیشن‌های کسب درآمد ایرانی و یا خارجی در کارسود ممنوع می‌باشد" +
            "\n" +
            "4- معرفی وب سایت‌ها و اپلیکیشن‌های شرط‌بندی و قمار ممنوع می‌باشد" +
            "\n" +
            "5- استفاده از عکس‌ها و بنرهای با پوشش نامناسب و خارج از عرف ممنوع می‌باشد"
    
    
        sweetAlert({
            show: true,
            showCancelButton: false,
            html: `${text}`,
            confirmButtonText: "مشاهده شد",
            cancelButtonText: "لغو",
            marginTop:"20px"
        })
    }

    return (
        <footer className="content-footer footer bg-footer-theme">
            <div id="footerNav" className="footer-nav-area">
                <div className="container m-0 h-100 px-0">
                    <div className="suha-footer-nav h-100">
                        <ul className="h-100 d-flex align-items-center justify-content-between ps-0 pe-0">
                            <li onClick={()=>navigate("/user-wallet")}><span><i className="bx bx-wallet"/>کیف پول من</span></li>
                            <li onClick={()=>setIsOpen(true)}><span><i className="bx bx-plus-circle"/>ثبت تبلیغ</span></li>
                            {/* <li><span><i className="bx bx-file"/>تراکنش ها</span></li> */}
                            <li onClick={()=>navigate("/dashboard")}><span ><i className="bx bxs-home"/>خانه</span></li>
                            <li onClick={()=>navigate("/contact-us")}><span><i className="bx bx-phone"/>ارتباط با ما</span></li>
                            <li onClick={()=>navigate("/user-profile")}><span><i className="bx bx-user"/>کارسود من</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <Modal
                style={{backgroundColor: '#555'}}
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                size="xl"
                backColor="#555"
            >
                <div className={"row"}>

                    <div className="col-xl-12">
                    <div className="col-12 mb-2">
                        <p style={{color: "white"}}>
                            لطفا حتما قبل از ثبت تبلیغ خود، موارد مهم و قوانین ثبت تبلیغ را مطالعه نمایید.
                        </p>
                    </div>
                        <div className="col-12 mb-2" style={{textAlign: "center"}}>
                            <Link onClick={(e)=>{
                                e.preventDefault();
                                showPolicy();
                                }} className="btn btn-primary me-3  ms-auto w-50 bg-primary"> مطالعه قوانین</Link>
                        </div>

                        <div className="col-12 mb-2">
                            <Link to="/my-advertisement/new" onClick={()=>setIsOpen(false)} className="btn btn-warning me-3  ms-auto w-100 bg-warning"> <i className="bx bx-plus-circle"/> ثبت تبلیغ جدید</Link>
                            {/* <button style={{marginBottom: '6px'}} className="btn btn-primary me-3  ms-auto w-100 bg-primary" type={"button"}
                                    onClick={()=>navigate("/my-advertisement/list?page=1&pageSize=20")}> + ثبت تبلیغ جدید
                            </button> */}
                        </div>
                        <div className="col-12 mb-1">
                            <Link to="/my-advertisement/list?page=1&pageSize=20" onClick={()=>setIsOpen(false)} className="btn btn-warning me-3  ms-auto w-100 bg-warning">تبلیغات من</Link>
                            {/* <button className="btn btn-primary me-3  ms-auto w-100 bg-primary" type={"button"}
                                    onClick={()=>navigate("/my-advertisement/new")}
                                    > تبلیغات من
                            </button> */}
                        </div>
                    </div>

                </div>
            </Modal>
        </footer>
    )
}